import { BaseChatPackage } from '../utils'
import { UseClientConfig } from './useClientConfig'
import { UseGroupDescription } from './useGroupDescription'
import { UseMentionsLimit } from './useMentionsLimit'
import { UseMentionSuggestions } from './useMentionSuggestions'
import { useSyncUserUpdates } from './useSyncUserUpdates'
import { UseSyncChannelMembers } from './useSyncChannelMembers'

export interface ChatHooks extends UseGroupDescription, UseClientConfig, UseMentionSuggestions, UseSyncChannelMembers, UseMentionsLimit {
  useSyncUserUpdates: typeof useSyncUserUpdates
}
export class ChatHooks extends BaseChatPackage {

  constructor(...args: ConstructorParameters<typeof BaseChatPackage>) {
    super(...args)
    const hooks = [
      new UseGroupDescription(...args),
      new UseClientConfig(...args),
      new UseMentionSuggestions(...args),
      new UseSyncChannelMembers(...args),
      new UseMentionsLimit(...args),
    ]

    for (const hook of hooks) {
      this.bindMethods(hook)
    }

    this.bindProperties({
      useSyncUserUpdates,
    })
  }
}

export * from './useClientConfig'
export * from './useGroupDescription'
export * from './useMentionSuggestions'
export * from './useSyncChannelMembers'
export * from './useChatListeners'
export * from './useMyMembership'
export * from './useChatEventsDebounced'
export * from './useChatBadgeCount'
export * from './useChatDMUser'
export * from './useChatUserImage'
export * from './useSyncUnreadState'
export * from './useSyncUserUpdates'
